import { useProfile } from '@/hooks/useProfile';

export function useReferralCode() {
  const { profile, isLoading } = useProfile();

  return {
    data: profile?.referral_code ?? null,
    isLoading,
  };
}
